import { RESET_DASHBOARD_PAGINATION } from 'actions';

export default function resetDashboardPagination() {
  return {
    type: RESET_DASHBOARD_PAGINATION,
  };
}
